import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=798e54c0&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=ts"
export * from "./navigation.vue?vue&type=script&lang=ts"
import style0 from "./navigation.vue?vue&type=style&index=0&id=798e54c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798e54c0",
  null
  
)

export default component.exports